export default [
  {
    name: 'Trials of the Nine',
    items: [
      174804902,
      1187594590,
      1825472717,
      1879212552,
      1909527966,
      2094938673,
      2850415209,
      3854037061,
      400025383,
      2641591726,
      548290754,
      854160040,
      238320915,
      400025382,
      2641591727,
      548290755,
      854160041,
      238320914,
      2391227801,
      1863012880,
      934145080,
      2221648234,
      3624606677,
      2391227800,
      1863012881,
      934145081,
      2221648235,
      3624606676,
      2964441920,
      530515217,
      891933383,
      4232174819,
      1607431126,
      2964441921,
      530515216,
      891933382,
      4232174818,
      1607431127
    ]
  },
  {
    name: 'Leviathan',
    items: [
      2505533224,
      3325744914,
      3906942101,
      1128225405,
      3954531357,
      3380742308,
      3691881271,
      1018072983,
      2013109092,
      1960303677,
      407863747,
      30962015,
      3984534842,
      2013109093,
      1960303676,
      407863746,
      30962014,
      3984534843,
      1413589586,
      1879942843,
      1876645653,
      288406317,
      574137192,
      1413589587,
      1879942842,
      1876645652,
      288406316,
      574137193,
      2700598111,
      2676042150,
      3592548938,
      2193494688,
      3763332443,
      2700598110,
      2676042151,
      3592548939,
      2193494689,
      3763332442
    ]
  },
  {
    name: 'Iron Banner',
    items: [
      2014642399,
      4425887,
      3890960908,
      1189790632,
      3424403076,
      2961807684,
      2909905776,
      807192446,
      1496224967,
      3737894478,
      831464034,
      1526005320,
      479917491,
      1804445917,
      691332172,
      3865618708,
      1337167606,
      738938985,
      2811201658,
      287471683,
      124696333,
      2674485749,
      2999505920
    ]
  },
  {
    name: 'Dead Orbit',
    items: [
      1587439031,
      582335600,
      48361213,
      1277015089,
      48361212,
      472847207,
      1459443448,
      2625782212,
      2625782213,
      3252697558,
      132368575,
      66235782,
      3146241834,
      3920232320,
      3783059515,
      1978760489,
      4065136800,
      387100392,
      2760076378,
      2089197765,
      3299588760,
      3763392361,
      2873960175,
      4055334203,
      4121118846
    ]
  },
  {
    name: 'New Monarchy',
    items: [
      705774642,
      3435238842,
      3889907763,
      1988218406,
      3435238843,
      2693941407,
      227548887,
      3239754990,
      2276266837,
      755928510,
      25798127,
      3323316553,
      600401425,
      342618372,
      3059968532,
      1890693805,
      2154427219,
      2603069551,
      106359434,
      316745113,
      4083497488,
      2436244536,
      147165546,
      831738837
    ]
  },
  {
    name: 'Future War Cult',
    items: [
      408440598,
      3854359821,
      1342668638,
      3272713429,
      1006783454,
      1339362514,
      2581162758,
      3329842376,
      4145119417,
      1763431309,
      2415993980,
      1355893732,
      1418921862,
      2524181305,
      1187431263,
      1162875302,
      3671665226,
      680327840,
      3842448731,
      2401598772,
      807866445,
      3656154099,
      1478665487,
      1566612778
    ]
  },
  {
    name: 'European Dead Zone Gear',
    items: [
      3762467078,
      1885753222,
      2145476620,
      1911843789,
      1513927138,
      287042893,
      731147177,
      2502422772,
      1983332560,
      3312073054,
      3973359167,
      3907226374,
      2729740202,
      3466255616,
      3366557883,
      3080875433,
      872284448,
      10307688,
      3862191322,
      1712405061,
      3764013786,
      1664741411,
      2724176749,
      4051755349,
      1304122208
    ]
  },
  {
    name: 'Echo Mesa, Io Gear',
    items: [
      3762467079,
      1911843788,
      731147179,
      287042894,
      3312073055,
      2502422775,
      417474226,
      1983332562,
      2715114534,
      1729074423,
      1085797441,
      3537609113,
      1868302492,
      1370341044,
      4071576013,
      2523633779,
      447407759,
      434092458,
      1554079989,
      229923140,
      3388454204,
      2160569198,
      845354673
    ]
  },
  {
    name: 'New Pacific Arcology Gear',
    items: [
      3762467077,
      1885753223,

      2145476623,
      1911843790,

      2700862856,
      3312073052,

      1513927136,
      287042892,

      2502422774,
      417474224,
      1607012852,
      479417869,
      2380978355,
      1150216911,
      291437034,
      2930137294,
      3955340735,
      1847610489,
      2876590849,
      3586337076,
      2575848725,
      1251692004,
      2400621276,
      2757777294,
      3686454865
    ]
  },
  {
    name: 'Arcadian Valley, Nessus Gear',
    items: [
      3762467076,
      1885753220,
      2145476622,
      1911843791,
      1513927139,
      2700862858,
      3312073053,
      2502422773,
      417474225,
      1983332561,
      3026265798,
      2423003287,
      2462524641,
      3807183801,
      3669590332,
      1010733668,
      957928253,
      177493699,
      3323553887,
      3754164794,
      2811068561,
      1427620200,
      2359639520,
      2528959426,
      1669675549
    ]
  },
  {
    name: 'Vanguard Tactician Gear',
    items: [
      1644162710,
      1960218487,
      1200414607,
      3582424018,
      3967155859,
      1351035691,
      339163900,
      137879537,
      2290863050,
      3445437901,
      2168486467,
      3198744410,
      1099472035,
      406401261,
      3486485973,
      3281314016,
      3873435116,
      3027732901,
      1667528443,
      3375062567,
      24244626,
      1540376513,
      2378296024,
      34846448,
      413460498,
      3215392301
    ]
  },
  {
    name: 'Vanguard Research Gear',
    items: [
      4248632159,
      4224076198,
      385045066,
      3741528736,
      555828571,
      4081859017,
      1490387264,
      2682045448,
      185326970,
      89175653,
      2615512594,
      3081969019,
      868792277,
      1532009197,
      4285708584
    ]
  },
  {
    name: 'Crucible Engram',
    items: [
      3336215727,
      4193877020,
      1048266744,
      1325579289,
      962412079,
      4174481098,
      2660862359,
      1773600468,
      2621637518,
      3223280471,
      2296691422,
      2718495762,
      3140634552,
      3313736739,
      2191401041,
      849529384,
      2815422368,
      1484937602,
      1742680797,
      1764274932,
      636679949,
      1333087155,
      1307478991,
      3538513130
    ]
  },
  {
    name: 'Gunsmith Arsenal',
    items: [
      3778520451,
      3778520450,
      273396910,
      925326393,
      925326392,
      925326394,
      3860697510,
      3860697508,
      1533499360,
      1533499361,
      1533499362,
      566976652,
      566976653,
      566976654,
      339343291,
      339343290,
      3748713779,
      3748713778,
      3666954562,
      3666954561,
      3666954563,
      2703340117,
      2398848320,
      896923850,
      3778520449
    ]
  },
  {
    name: 'Bright Engram, Eververse',
    items: [
      1869779952,
      1625986881,
      369186071,
      2696374963,
      2497505510,
      1638376198,
      652336087,
      415074081,
      2460870905,
      1197579132,
      2956899553,
      3794819064,
      199852048,
      1830086706,
      3421974605
    ]
  },
  {
    name: 'Engrams',
    items: [
      3125909492,
      1998314509,
      316000947,
      2669113551,
      2521426922,
      2550994842,
      493299171,
      1024867629,
      2414278933,
      3433746208,
      269552461,
      922218300,
      1415533220,
      308026950,
      2159363321,
      155832748,
      3646674533,
      3066593211,
      3569443559,
      1847870034,
      160388292,
      107582877,
      2696303651,
      2048751167,
      1978110490,
      2525344810,
      2530905971,
      1364856221,
      2265859909,
      2826844112,
      3725654227,
      1260134370,
      2932121030,
      3304280092,
      3250112431,
      690335398,
      3999262583,
      3291075521,
      1512829977,
      4073580572,
      2791527489,
      3629447000,
      3884999792,
      1664611474,
      2770578349,
      2542514983,
      489114030,
      683173058,
      2996649640,
      373203219,
      993844472,
      1457647945,
      410671183,
      1749589787,
      2082184158,
      2811180959,
      3169402598,
      4092393610,
      2728535008,
      434243995
    ]
  },
  {
    name: 'Eververse',
    items: [
      2833999140,
      2833999141,
      2833999142,
      2833999143,
      2833999136,
      2833999137,
      2833999138,
      2833999139,
      2833999148,
      2833999149,
      261110023,
      261110022,
      261110024,
      261110025,
      261110026,
      261110027,
      261110028,
      261110030,
      261110031,
      261110029,
      277887714,
      277887715,
      277887712,
      277887713,
      277887718,
      93029343,
      93029342,
      292778444,
      454583975,
      2543806755,
      412299646,
      664042851,
      938804347,
      3129418034,
      3872116425,
      1120064792,
      718136887,
      2741695224,
      1061186327,
      4223882778,
      2649911453,
      1177179936,
      1954221115,
      2870168892,
      4187524534,
      3199368173,
      3811760832,
      1294717622,
      2526538979,
      3526028978,
      333041308,
      807458183,
      807458182,
      807458181,
      3889183914,
      3889183915,
      3889183912,
      3889183913,
      3889183918,
      3889183919,
      3889183916,
      3889183917,
      3889183906,
      3889183907,
      2546958593,
      2546958592,
      2546958594,
      2546958597,
      2546958596,
      2546958599,
      2546958598,
      904825093,
      904825092,
      904825094,
      904825089,
      904825088,
      2503134037,
      838210459,
      4209989368,
      96858972,
      3213307847,
      1104161649,
      2503134032,
      2503134038,
      2503134039,
      2503134036,
      2503134042,
      838210457,
      838210456,
      4209989372,
      4209989373,
      4209989370,
      4209989371,
      4209989369,
      4209989366,
      96858973,
      4209989367,
      3213307843,
      3213307842,
      3213307845,
      3213307844,
      3213307846,
      3213307849,
      3213307848
    ]
  }
]



// WEBPACK FOOTER //
// ./src/domain/sourceData.js